<!-- Begin: Page Footer -->
<footer id="content-footer" class="affix">
    <div class="row">
        <div class="col-md-6">
            <span class="footer-legal">© 2015 AdminDesigns</span>
        </div>
        <div class="col-md-6 text-right">
            <span class="footer-meta">60GB of <b>350GB</b> Free</span>
            <a href="#content" class="footer-return-top">
                <span class="fa fa-arrow-up"></span>
            </a>
        </div>
    </div>
</footer>
<!-- End: Page Footer -->